import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    // alwaysShow: true,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'el-icon-s-custom' }
    },{
      path: '/msgCenter',
      name: 'MsgCenter',
      component: () => import('@/views/msg/center/index.vue'),
      meta: { title: '消息中心' },
      hidden: true
    } ,{
      path: '/personalInformation',
      name: 'PersonalInformation',
      component: () => import('@/views/personalInformation/index.vue'),
      meta: { title: '个人信息' },
      hidden: true
    }]
  },


  // {
  //   path: '/dataDisplay',
  //   component: Layout,
  //   // hidden: true,
  //   redirect: '/dataDisplay/index',
  //   meta: { title: '系统管理', icon: 'el-icon-s-tools' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'DataDisplay',
  //       component: () => import('@/views/dataDisplay/index'),
  //       meta: { title: '数据看板(简易版)', icon: 'el-icon-s-data' }
  //     }
  //   ]
  // },
  // {
  //   path: '/partnersAdminister',
  //   component: Layout,
  //   redirect: '/partnersAdminister/joinIn',
  //   name: 'partnersAdminister',
  //   meta: { title: '合作商管理', icon: 'icon-partners' },
  //   children: [
  //     {
  //       path: '/joinIn',
  //       name: 'JoinIn',
  //       component: () => import('@/views/partnersAdminister/joinIn/index'),
  //       meta: { title: '加盟商管理', icon: 'el-icon-s-shop' }
  //     },
  //     {
  //       path: '/store',
  //       name: 'Store',
  //       component: () => import('@/views/partnersAdminister/store/index'),
  //       meta: { title: '门店管理', icon: 'el-icon-s-shop' }
  //     },
  //     {
  //       path: '/storeCard',
  //       name: 'StoreCard',
  //       component: () => import('@/views/partnersAdminister/storeCard/index'),
  //       meta: { title: '门店权益卡', icon: 'icon-theRightsAndInterests' }
  //     },
  //     {
  //       path: '/storeService',
  //       name: 'StoreService',
  //       component: () => import('@/views/partnersAdminister/storeService/index'),
  //       meta: { title: '门店服务管理', icon: 'el-icon-s-goods' }
  //     },
  //     {
  //       path: 'staff',
  //       name: 'Staff',
  //       component: () => import('@/views/partnersAdminister/staff/index'),
  //       meta: { title: '员工管理', icon: 'el-icon-user' }
  //     },
  //     {
  //       hidden: true,
  //       path: 'turnover',
  //       name: 'Turnover',
  //       component: () => import('@/views/partnersAdminister/store/turnover'),
  //       meta: { title: '门店营业数据' }
  //     },
  //     {
  //       path: 'equipment',
  //       name: 'Equipment',
  //       component: () => import('@/views/partnersAdminister/equipment/index'),
  //       meta: { title: '设备管理', icon: 'icon-equipment' }
  //     }
  //   ]
  // }
  // {
  //   path: '/oms',
  //   component: Layout,
  //   // redirect: '/oms/orderList',
  //   name: 'oms',
  //   meta: { title: '订单管理', icon: 'el-icon-s-order' },
  //   children: [
  //     {
  //       path: 'orderList',
  //       name: 'OrderList',
  //       component: () => import('@/views/oms/orderList/index'),
  //       meta: {
  //         title: '订单管理', icon: 'el-icon-message-solid'
  //       }
  //     },
  //     // {
  //     //   path: 'drainageOrder', // 废弃页面
  //     //   name: 'DrainageOrder',
  //     //   component: () => import('@/views/oms/drainageOrder/index'),
  //     //   meta: { title: '引流订单', icon: 'el-icon-s-order' }
  //     // },
  //     {
  //       path: 'afterSalesOrder',
  //       name: 'OfterSalesOrder',
  //       component: () => import('@/views/oms/afterSalesOrder/index'),
  //       meta: { title: '售后订单管理', icon: 'el-icon-s-order' }
  //     },
  //     {
  //       path: 'appointmentOrder',
  //       name: 'AppointmentOrder',
  //       component: () => import('@/views/oms/appointmentOrder/index'),
  //       meta: { title: '预约订单管理', icon: 'el-icon-s-order' }
  //     },
  //     {
  //       path: 'managerPlaceOrderList',
  //       name: 'ManagerPlaceOrderList',
  //       component: () => import('@/views/oms/managerPlaceOrderList/index'),
  //       meta: { title: 'B端订单管理', icon: 'el-icon-s-order' }
  //     },
  //     {
  //       path: 'couponPurchaseList',
  //       name: 'CouponPurchaseList',
  //       component: () => import('@/views/oms/couponPurchaseList/index'),
  //       meta: { title: '优惠券订单', icon: 'el-icon-s-order' }
  //     }
  //   ]
  // },
  // {
  //   path: '/serve',
  //   component: Layout,
  //   redirect: '/serve/serviceItems',
  //   meta: { title: '服务管理', icon: 'el-icon-s-goods' },
  //   children: [
  //     {
  //       path: 'serviceItems',
  //       name: 'ServiceItems',
  //       component: () => import('@/views/serve/serviceItems/index'),
  //       meta: {
  //         title: '服务项目管理', icon: 'el-icon-s-goods'
  //       }
  //     },
  //     {
  //       path: 'serviceAudit',
  //       name: 'ServiceAudit',
  //       component: () => import('@/views/serve/serviceAudit/index'),
  //       meta: { title: '服务审核管理', icon: 'icon-afterSales' }
  //     }
  //   ]
  // },
  // // 耗材管理
  // {
  //   path: '/consumablesManage',
  //   component: Layout,
  //   // redirect: '/consumablesManage/consumables',
  //   meta: { title: '耗材管理', icon: 'icon-consumables' },
  //   alwaysShow: true,
  //   // hidden: true,
  //   children: [
  //     {
  //       path: 'consumables',
  //       name: 'Consumables',
  //       component: () => import('@/views/consumablesManage/consumables/index'),
  //       meta: {
  //         title: '耗材管理', icon: 'icon-consumables'
  //       }
  //     },
  //     {
  //       path: 'consumablesDeploy',
  //       name: 'ConsumablesDeploy',
  //       component: () => import('@/views/consumablesManage/consumablesDeploy/index'),
  //       meta: {
  //         title: '耗材配置', icon: 'el-icon-s-tools'
  //       }
  //     },
  //     {
  //       path: 'deliverGoods',
  //       name: 'DeliverGoods',
  //       component: () => import('@/views/consumablesManage/deliverGoods/index'),
  //       meta: {
  //         title: '发货管理', icon: 'icon-theDelivery'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/couponMana',
  //   component: Layout,
  //   redirect: '/couponMana/newCoupons',
  //   meta: { title: '优惠券管理', icon: 'icon-coupon' },
  //   children: [
  //     {
  //       path: 'newCoupons',
  //       name: 'NewCoupons',
  //       component: () => import('@/views/couponMana/newCoupons/index'),
  //       meta: {
  //         title: '优惠券', icon: 'icon-coupon'
  //       }
  //     },
  //     {
  //       path: 'bindingCoupon',
  //       name: 'BindingCoupon',
  //       component: () => import('@/views/couponMana/bindingCoupon/index'),
  //       meta: {
  //         title: '门店优惠券', icon: 'icon-coupon'
  //       }
  //     },
  //     {
  //       hidden: true,
  //       path: 'buyDetails',
  //       name: 'BuyDetails',
  //       component: () => import('@/views/couponMana/details/buyDetails'),
  //       meta: {
  //         title: '门店优惠券购买明细'
  //         // noCache: true
  //       }
  //     },
  //     {
  //       hidden: true,
  //       path: 'issueDetails',
  //       name: 'IssueDetails',
  //       component: () => import('@/views/couponMana/details/issueDetails'),
  //       meta: {
  //         title: '门店优惠券发放明细'
  //         // noCache: true
  //       }
  //     }
  //   ]
  // },
  // // 权益卡管理
  // {
  //   path: '/discountCardMange',
  //   component: Layout,
  //   redirect: '/discountCardMange/discountCardConfig',
  //   meta: { title: '权益卡管理', icon: 'icon-theRightsAndInterests' },
  //   // hidden: true,
  //   children: [
  //     {
  //       path: 'discountCardConfig',
  //       name: 'DiscountCardConfig',
  //       component: () => import('@/views/discountCardMange/discountCardConfig/index'),
  //       meta: {
  //         title: '权益卡配置', icon: 'icon-theRightsAndInterests'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/activityManagement',
  //   component: Layout,
  //   redirect: '/activityManagement/activity',
  //   meta: { title: '活动管理', icon: 'icon-activity' },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: 'activity',
  //       name: 'Activity',
  //       component: () => import('@/views/activityManagement/activity/index'),
  //       meta: {
  //         title: '活动', icon: 'icon-activity'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/reportsManage',
  //   component: Layout,
  //   redirect: '/reportsManage/operationLog',
  //   meta: { title: '预检报告管理', icon: 'icon-preview' },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: 'templateManager',
  //       name: 'TemplateManager',
  //       component: () => import('@/views/reportsManage/templateManager/index'),
  //       meta: {
  //         title: '模板管理', icon: 'icon-template'
  //       }
  //     },
  //     {
  //       // hidden: true, // 暂时隐藏(待开发页面)
  //       path: 'previewManager',
  //       name: 'PreviewManager',
  //       component: () => import('@/views/reportsManage/previewManager/index'),
  //       meta: {
  //         title: '预检管理', icon: 'icon-preview'
  //       }
  //     }
  //   ]
  // },

  // {
  //   path: '/systemManagement',
  //   component: Layout,
  //   redirect: '/systemManagement/operationLog',
  //   meta: { title: '系统管理', icon: 'el-icon-s-tools' },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: 'userList',
  //       name: 'UserList',
  //       component: () => import('@/views/systemManagement/userList'),
  //       meta: {
  //         title: '账号管理', icon: 'icon-theLog'
  //       }
  //     },
  //     {
  //       path: 'roleList',
  //       name: 'RoleList',
  //       component: () => import('@/views/systemManagement/roleList'),
  //       meta: {
  //         title: '角色管理', icon: 'icon-theLog'
  //       }
  //     },
  //     {
  //       path: 'menuList',
  //       name: 'MenuList',
  //       component: () => import('@/views/systemManagement/menuList/index'),
  //       meta: {
  //         title: '菜单管理', icon: 'icon-theLog'
  //       }
  //     },
  //     {
  //       path: 'operationLog',
  //       name: 'OperationLog',
  //       component: () => import('@/views/systemManagement/operationLog/index'),
  //       meta: {
  //         title: '操作日志', icon: 'icon-theLog'
  //       }
  //     }
  //   ]
  // }
  // {
  //   path: '/generalSettings',
  //   component: Layout,
  //   redirect: '/generalSettings/appointmentConfig',
  //   meta: { title: '通用配置', icon: 'el-icon-s-tools' },
  //   alwaysShow: true,
  //   children: [
  //     {
  //       path: 'appointmentConfig',
  //       name: 'AppointmentConfig',
  //       component: () => import('@/views/generalSettings/appointmentConfig/index'),
  //       meta: {
  //         title: '预约配置', icon: 'icon-theLog'
  //       }
  //     },
  //     {
  //       path: 'placeOrderLimit',
  //       name: 'PlaceOrderLimit',
  //       component: () => import('@/views/generalSettings/placeOrderLimit/index'),
  //       meta: {
  //         title: '限制下单', icon: 'icon-theLog'
  //       }
  //     },
  //     {
  //       path: 'noticeConfig',
  //       name: 'NoticeConfig',
  //       component: () => import('@/views/generalSettings/noticeConfig/index'),
  //       meta: {
  //         title: '通知配置', icon: 'icon-theLog'
  //       }
  //     }
  //   ]
  // }
  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
]

export const asyncRouterMap = []

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
